module.exports = __webpack_public_path__ + "static/media/facebook-dashboard.9684dc5d.svg";